<template>
  <div :class="wrapClasses">
    <div :class="outerClasses">
      <div :class="innerClasses" :style="innerStyle">
        <div :class="bgClasses" :style="bgStyle"></div>
        <div :class="successBgClasses" :style="successBgStyle"></div>
      </div>
    </div>
    <span v-if="!hideInfo" :class="textClasses">
      <slot>
        <span v-if="isStatus" :class="textInnerClasses">
          <!-- <Icon :type="statusIcon"></Icon> -->
           <slot name="Icon"></slot>
        </span>
        <span v-else :class="textInnerClasses"> {{ percent }}% </span>
      </slot>
    </span>
  </div>
</template>
<script>
// import Icon from '../icon';
import { oneOf } from '../../plugins/utils';

const prefixCls = 'ivu-progress';

export default {
  name: 'Progress',
  // components: { Icon },
  props: {
    percent: {
      type: Number,
      default: 0
    },
    successPercent: {
      type: Number,
      default: 0
    },
    status: {
      validator(value) {
        return oneOf(value, ['normal', 'active', 'wrong', 'success']);
      },
      default: 'normal'
    },
    hideInfo: {
      type: Boolean,
      default: false
    },
    strokeWidth: {
      type: Number,
      default: 10
    },
    vertical: {
      type: Boolean,
      default: false
    },
    isBorderRadius: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentStatus: this.status
    };
  },
  computed: {
    isStatus() {
      return this.currentStatus === 'wrong' || this.currentStatus === 'success';
    },
    statusIcon() {
      let type = '';
      switch (this.currentStatus) {
        case 'wrong':
          type = 'ios-close-circle';
          break;
        case 'success':
          type = 'ios-checkmark-circle';
          break;
      }

      return type;
    },
    bgStyle() {
      return this.vertical ? {
        height: `${this.percent}%`,
        width: `${this.strokeWidth}px`,
        isBorderRadius: this.isBorderRadius ? '10px' : '0px'
      } : {
        width: `${this.percent}%`,
        height: `${this.strokeWidth}px`,
        BorderRadius: this.isBorderRadius ? '10px' : '0px'
      };
    },
    successBgStyle() {
      return this.vertical ? {
        height: `${this.successPercent}%`,
        width: `${this.strokeWidth}px`,
        BorderRadius: this.isBorderRadius ? '10px' : '0px'
      } : {
        width: `${this.successPercent}%`,
        height: `${this.strokeWidth}px`,
        BorderRadius: this.isBorderRadius ? '10px' : '0px'
      };
    },
    innerStyle() {
      return {
        BorderRadius: this.isBorderRadius ? '10px' : '0px'
      };
    },
    wrapClasses() {
      return [
        `${prefixCls}`,
        `${prefixCls}-${this.currentStatus}`,
        {
          [`${prefixCls}-show-info`]: !this.hideInfo,
          [`${prefixCls}-vertical`]: this.vertical

        }
      ];
    },
    textClasses() {
      return `${prefixCls}-text`;
    },
    textInnerClasses() {
      return `${prefixCls}-text-inner`;
    },
    outerClasses() {
      return `${prefixCls}-outer`;
    },
    innerClasses() {
      return `${prefixCls}-inner`;
    },
    bgClasses() {
      return `${prefixCls}-bg`;
    },
    successBgClasses() {
      return `${prefixCls}-success-bg`;
    }
  },
  created() {
    this.handleStatus();
  },
  methods: {
    handleStatus(isDown) {
      if (isDown) {
        this.currentStatus = 'normal';
        this.$emit('on-status-change', 'normal');
      } else if (parseInt(this.percent, 10) === 100) {
        this.currentStatus = 'success';
        this.$emit('on-status-change', 'success');
      }
    }
  },
  watch: {
    percent(val, oldVal) {
      if (val < oldVal) {
        this.handleStatus(true);
      } else {
        this.handleStatus();
      }
    },
    status(val) {
      this.currentStatus = val;
    }
  }
};
</script>
<style lang="scss">
$css-prefix: 'ivu-';
$font-size-small: 12px;
// $primary-color: #2d8cf0;
$primary-color: var(--c-primary);
$success-color: var(--c-primary);
$error-color: #ed4014;
$transition-time: 0.3s;
$ease-in-out: ease-in-out;
$progress-prefix-cls: #{$css-prefix}progress;

.#{$progress-prefix-cls} {
    display: inline-block;
    width: 100%;

    &-vertical {
        height: 100%;
        width: auto;
    }

    font-size: $font-size-small;
    position: relative;

    &-outer {
        display: inline-block;
        width: 100%;
        margin-right: 0;
        padding-right: 0;

        .#{$progress-prefix-cls}-show-info & {
            padding-right: 55px;
            margin-right: -55px;
        }
    }

    &-vertical &-outer {
        height: 100%;
        width: auto;
    }

    &-inner {
        display: inline-block;
        width: 100%;
        background-color: #f3f3f3;
        border-radius: 100px;
        vertical-align: middle;
        position: relative;
    }

    &-vertical &-inner {
        height: 100%;
        width: auto;

        & > *, &:after {
            display: inline-block;
            vertical-align: bottom;
        }

        &:after {
            content: '';
            height: 100%;
        }
    }

    &-bg {
        border-radius: 100px;
        background-color: $primary-color;
        transition: all $transition-time linear;
        position: relative;
    }

    &-success-bg {
        border-radius: 100px;
        background-color: $success-color;
        transition: all $transition-time linear;
        position: absolute;
        top: 0;
        left: 0;
    }

    &-text {
        display: inline-block;
        margin-left: 5px;
        text-align: left;
        font-size: 1em;
        vertical-align: middle;
    }

    &-active {
        .#{$progress-prefix-cls}-bg:before {
            content: '';
            opacity: 0;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: #fff;
            border-radius: 10px;
            animation: ivu-progress-active 2s $ease-in-out infinite;
        }
    }

    // &-vertical&-active {
    //     .#{$progress-prefix-cls}-bg:before {
    //         top: auto;
    //         animation: ivu-progress-active-vertical 2s $ease-in-out infinite;
    //     }
    // }
    &-vertical {
      &-active {
        .#{$progress-prefix-cls}-bg:before {
          top: auto;
          animation: ivu-progress-active-vertical 2s $ease-in-out infinite;
        }
      }
    }
    &-wrong {
        .#{$progress-prefix-cls}-bg {
            background-color: $error-color;
        }
        .#{$progress-prefix-cls}-text {
            color: $error-color;
        }
    }

    &-success {
        .#{$progress-prefix-cls}-bg {
            background-color: $success-color;
        }
        .#{$progress-prefix-cls}-text {
            color: $success-color;
        }
    }
}

@keyframes ivu-progress-active {
    0% {
        opacity: .3;
        width: 0;
    }
    100% {
        opacity: 0;
        width: 100%;
    }
}

@keyframes ivu-progress-active-vertical {
    0% {
        opacity: .3;
        height: 0;
    }
    100% {
        opacity: 0;
        height: 100%;
    }
}

</style>
